import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { pushIf } from "./utils/pushIf";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceZonesRetrievalNotificationState = createStateReducer(initialState, {
  [events.retrieveZonesFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "retrieveZones",
        flags: pushIf({
          planzoneNotFound: error.wasPlanzoneNotFound,
          unExpectedError: error.hasUnexpectedError,
        }),
        args: { failure: "true", message: error.message },
      },
      state.queue,
    ),
  }),
});

export { reduceZonesRetrievalNotificationState };
